import { render } from "./BoxIconGridComponent.vue?vue&type=template&id=f4dd9262"
import script from "./BoxIconGridComponent.vue?vue&type=script&lang=js"
export * from "./BoxIconGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__